var map = {
	"./on-arrow-down.png": "61ca",
	"./on-collection.png": "37f7",
	"./on-data.png": "d331",
	"./on-employ.png": "7cdb",
	"./on-finance.png": "5fdc",
	"./on-goods.png": "621f",
	"./on-member.png": "b05b",
	"./on-more.png": "e645",
	"./on-reception.png": "a260",
	"./on-store.png": "00c1",
	"./on-stu.png": "aa80",
	"./on-summary.png": "a033",
	"./on-work.png": "c6a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a66";